import { Environment } from "@app/interfaces/environment.interface";

export const environment:Environment = {
    production: false,
    apiUrl: 'https://dev.app.arborsense.com/v1/core',
    authUrl: 'https://dev.app.arborsense.com/v1/auth',
    utilityUrl: 'https://dev.app.arborsense.com/v1/utility',
    frontendUrl: 'https://dev.app.arborsense.com',
};